import Avatar from 'react-avatar';
import Select from 'react-select';
import styles from './UserEigentuemerApp.module.css';
import moment from 'moment-timezone';
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useTypedSelector } from '../../../../../hooks/useTypedSelector';
import { useActions } from '../../../../../hooks/useActions';
import useMultiLanguageFieldValue from '../../../../../hooks/useMultiLanguageFieldValue';
import MultiLanguageInput from '../../../../../components/MultiLanguageInput/MultiLanguageInput';
import fireToast from '../../../../benit/central-ui/methods/fireToast';
import showConfirmPopup from '../../../../benit/central-ui/methods/showConfirmPopup';
import { LoadingAnimation } from '../../../../../components/LoadingAnimation/LoadingAnimation';

const ConfigurationApp = () => {
    const [ftpConfig, setFtpConfig] = useState<{ [x: string]: string }>({
        host: '',
        port: '',
        user: '',
        password: '',
    });
    const [dataSyncConfig, setDataSyncConfig] = useState<{ [x: string]: string }>({
        syncHour: '',
        lastUpdateAt: '',
        nextUpdateAt: '',
        expirationId: '',
        lastTransaction: '',
    });
    const { t } = useTranslation(['general', 'ri-property-management']);
    const { mlfv } = useMultiLanguageFieldValue();

    const { ri_property_management_get_configuration, ri_property_management_change_configuration } = useActions();

    const { configurationDidInvalidate, configurationUpdated, configurations } = useTypedSelector((state) => state.riPropertyManagementReducer);

    useEffect(() => {
        ri_property_management_get_configuration();
    }, []);

    useEffect(() => {
        if (configurationDidInvalidate) {
            ri_property_management_get_configuration();
        }
    }, [configurationDidInvalidate]);

    useEffect(() => {
        if (configurationUpdated) {
            fireToast('success', `Konfiguration gespeichert`);
        }
    }, [configurationUpdated]);

    useEffect(() => {
        if (configurations) {
            configurations.map((configuration) => {
                if (configuration.configIdentifier === 'ftpConfig') {
                    setFtpConfig(configuration.properties);
                }
                if (configuration.configIdentifier === 'dataSyncConfig') {
                    setDataSyncConfig(configuration.properties);
                }
            });
        }
    }, [configurations]);

    return (
        <div>
            <div className="row">
                <section className="col-lg-6 col-xl-3 connectedSortable">
                    <div className="card">
                        <div className="card-header">
                            <h3 className="card-title">
                                <i className="fas fa-tools mr-1"></i>
                                FTP
                            </h3>
                            <div className="card-tools">
                                <button type="button" className="btn btn-tool" data-card-widget="collapse">
                                    <i className="fas fa-minus"></i>
                                </button>
                            </div>
                        </div>
                        <div className="card-body">
                            <div className="form-group">
                                <label>FTP URL</label>
                                <input
                                    type="text"
                                    className="form-control"
                                    placeholder=""
                                    value={ftpConfig.host}
                                    onChange={(e) =>
                                        setFtpConfig({
                                            ...ftpConfig,
                                            host: e.target.value,
                                        })
                                    }
                                />
                            </div>
                            <div className="form-group">
                                <label>FTP Port</label>
                                <input
                                    type="text"
                                    className="form-control"
                                    placeholder=""
                                    value={ftpConfig.port}
                                    onChange={(e) =>
                                        setFtpConfig({
                                            ...ftpConfig,
                                            port: e.target.value,
                                        })
                                    }
                                />
                            </div>
                            <div className="form-group">
                                <label>FTP User Name</label>
                                <input
                                    type="text"
                                    className="form-control"
                                    placeholder=""
                                    value={ftpConfig.user}
                                    onChange={(e) =>
                                        setFtpConfig({
                                            ...ftpConfig,
                                            user: e.target.value,
                                        })
                                    }
                                />
                            </div>
                            <div className="form-group">
                                <label>FTP Password</label>
                                <input
                                    type="password"
                                    className="form-control"
                                    placeholder=""
                                    value={ftpConfig.password}
                                    onChange={(e) =>
                                        setFtpConfig({
                                            ...ftpConfig,
                                            password: e.target.value,
                                        })
                                    }
                                />
                            </div>
                        </div>
                        <div className="card-footer">
                            <div className="input-group">
                                <button className="btn btn-block btn-primary" onClick={(e) => ri_property_management_change_configuration('ftpConfig', ftpConfig)}>
                                    Konfiguration Speichern
                                </button>
                            </div>
                        </div>
                    </div>
                </section>
                <section className="col-lg-6 col-xl-3 connectedSortable">
                    <div className="card">
                        <div className="card-header">
                            <h3 className="card-title">
                                <i className="fas fa-tools mr-1"></i>
                                Synchronisierungseinstellung
                            </h3>
                            <div className="card-tools">
                                <button type="button" className="btn btn-tool" data-card-widget="collapse">
                                    <i className="fas fa-minus"></i>
                                </button>
                            </div>
                        </div>
                        <div className="card-body">
                            <div className="form-group">
                                <label>Sync Stunde</label>
                                <div className="input-group">
                                    <div className="input-group-prepend">
                                        <span className="input-group-text">Jeden Tag um</span>
                                    </div>
                                    <input
                                        type="number"
                                        min="0"
                                        max="24"
                                        className="form-control text-right"
                                        placeholder=""
                                        value={dataSyncConfig.syncHour}
                                        onChange={(e) =>
                                            setDataSyncConfig({
                                                ...dataSyncConfig,
                                                syncHour: e.target.value,
                                            })
                                        }
                                    />
                                    <div className="input-group-append">
                                        <span className="input-group-text">:00 Uhr</span>
                                    </div>
                                </div>
                            </div>
                            <div className="form-group">
                                <label>Letztes Update</label>
                                <div className="input-group">
                                    <input
                                        type="text"
                                        className="form-control text-right"
                                        placeholder=""
                                        value={dataSyncConfig.lastUpdateAt ? moment(dataSyncConfig.lastUpdateAt).tz('Europe/Berlin').format('DD.MM.YYYY HH:mm') : ''}
                                        disabled
                                    />
                                    <div className="input-group-append">
                                        <span className="input-group-text">Uhr</span>
                                    </div>
                                </div>
                            </div>
                            <div className="form-group">
                                <label>Letzte Buchung</label>
                                <div className="input-group">
                                    <input type="text" className="form-control text-right" placeholder="" value={dataSyncConfig.lastTransaction ? dataSyncConfig.lastTransaction : ''} disabled />
                                </div>
                            </div>
                            <div className="form-group">
                                <label>Nächstes Update</label>

                                <div className="input-group">
                                    <input
                                        type="text"
                                        className="form-control text-right"
                                        placeholder=""
                                        value={moment(dataSyncConfig.nextUpdateAt).tz('Europe/Berlin').format('DD.MM.YYYY HH:mm')}
                                        disabled
                                    />
                                    <div className="input-group-append">
                                        <span className="input-group-text">Uhr</span>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="card-footer">
                            <div className="input-group">
                                <button className="btn btn-block btn-primary" onClick={(e) => ri_property_management_change_configuration('dataSyncConfig', dataSyncConfig)}>
                                    Konfiguration Speichern
                                </button>
                            </div>
                        </div>
                    </div>
                </section>
            </div>
        </div>
    );
};

export default ConfigurationApp;
